module.exports = __webpack_public_path__ + "img/IMG_2618.eb0e9168.jpg";